import React from "react";
import {useNavigate} from "react-router-dom";

export function ProgressSteps({currentStep, steps, state, edit}) {

    const isAlways = state.name === "ALWAYS"

    const navigate = useNavigate();
    const arraySteps = Array.from({length: steps.length}, (_, i) => `Step ${i + 1}`)

    // NOTE: index 0 is the path to automation
    function handleOnClick(index) {
        if (!isAlways || index !== 0)
            if (edit || index + 1 < currentStep)
                navigate(steps[index], {state: {...state, currentStep: index + 1}});
    }

    return <>

        <div className="container my-2">
            <div className="d-flex justify-content-between mb-2">
                {arraySteps.map((step, index) => (
                    <div key={index}
                         className={`text-center flex-fill border-5 border-bottom ${isAlways && index === 0 && steps.length > 1 ?
                             'text-muted border-light-subtle' :
                             index + 1 <= currentStep ? 'fw-bold text-info border-info' : 'text-muted border-light-subtle'}`}
                         onClick={() => handleOnClick(index)}
                         style={{cursor: !(isAlways && index === 0) ? 'pointer' : undefined}}
                    >
                        {step}
                    </div>
                ))}
            </div>
        </div>

    </>
}